
import { useMemo } from 'react';

import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Base64 } from 'js-base64';

import { ILuxuryHome } from '@share/common-types';
import { RemoveLuxuryHomesParams, RootState } from '@share/utils';
import { Routes } from '@share/constants';

import './style.scss';

interface IProps {
  property: ILuxuryHome;
  
  onClick: () => void;
}

export function PropertyCard(props: IProps) {

  const { property } = props;
  const { thumb, title, description } = property;

  const history = useHistory();

  const { account } = useSelector((state: RootState) => state.loginStore);

  const unit = useMemo(() => {
    return property?.units?.flat()?.[0];
  }, [property]);

  const goToDetails = () => {
    props.onClick();

    RemoveLuxuryHomesParams();

    const propertyId = property?.id;
    const multipleUnits = property?.multipleUnits;

    if (multipleUnits) {
      const locationId = property?.location?.id;
      history.push(`/${account?.name}${Routes.LuxuryHomesPlace}/${locationId}/${propertyId}${location.search}`);
    } else {
      const roomId = Base64.encode(unit?.id);
      history.push(`/${account?.name}${Routes.LuxuryHomesDetails}/${propertyId}/${roomId}${location.search}`);
    }
  }
  
  return (
    <div className="condo-card-wrapper" style={{ cursor: 'pointer' }} onClick={goToDetails}>
      <div className="condo-card-wrapper__image">
        <div className="image-background" style={{ backgroundImage: `url(${thumb})`, height: '100%', width: '100%' }}></div>
        <div className="condo-card-wrapper__plaseholder">No Image Available</div>
      </div>
      <div className="condo-card-wrapper__content">
        <div className="condo-card-wrapper__condo-title">
          {title?.split(',')[0]}
        </div>

        <div className="condo-card-wrapper__available-unit">
          {description}
        </div>
      </div>

      <div className="condo-card-wrapper__triangle-down"></div>
    </div>
  );
}
